import { render } from "./direction.vue?vue&type=template&id=f687b3f2"
import script from "./direction.vue?vue&type=script&lang=js"
export * from "./direction.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__